import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'
import img5 from './img5.png'

const Kitchen = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Living Room Design App to Plan Layouts, Place Furniture, and Style Your Space"
        subtitle="Find living room ideas, plan your layout, and decorate virtually with an app made for living room design."
        bg={headerBg}
        meta={{
          title: 'Living Room Design App | Plan Layouts, Furniture, and Decor',
          description: 'Plan your living room layout, place real furniture, and explore decor ideas with our living room design app. Visualize your space before making changes and bring your dream living room to life.'
        }}
        alt="Modern living room designs created with DecorMatters app"
      />
      <Join
        title="Join Over 10 million users designing Living Rooms with"
        postfix=""
        description="Redesign your living room with ease using the DecorMatters living room design app. Plan layouts, place furniture, explore decor ideas, and visualize your space before making changes. Use powerful tools to test different styles and create your perfect layout — all from your phone."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Customize Your Living Room with Our Design App</H2>
            </Show>
            <Text>
              Whether you're into modern, boho, minimalist, or farmhouse aesthetics, the DecorMatters living room design app helps you discover and visualize your perfect style. Try out different layouts, place furniture, and experiment with colors,
              decor, and lighting — all before making a single purchase.
              <br />
              <br />
              Browse living room design ideas, customize every detail, and find what fits your space and personality.
              <br />
              <br />
              With the DecorMatters app, you can add and arrange:
              <br />
              <br />
              ● Living room furniture
              <br />
              ● Lighting and lamps
              <br />
              ● Rugs and flooring
              <br />
              ● Wall art and decor
              <br />
              ● Plants and greenery
              <br />● Coffee tables, sofas, and more
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Customize Your Living Room with Our Design App</H2>
            </Show>
            <Image src={img1} alt="Living room planner app showing layout customization" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Design Your Living Room and Share It with Our Creative Community</H2>
            </Show>
            <Text>
              DecorMatters lets you design your living room and get instant feedback from a vibrant creative community. Share your layouts, vote on others' designs, and join design challenges to improve your skills and get inspired. Whether you're a
              DIY home decorator or an aspiring interior designer, you'll find real users offering feedback and support.
              <br />
              <br />
              Want to compete? Submit your living room designs in our interior design game for a chance to win rewards and gain community recognition.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Design Your Living Room and Share It with Our Creative Community</H2>
            </Show>
            <Image src={img2} alt="User-generated living room designs from DecorMatters community" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Shop Living Room Furniture from Top Retailers in the App</H2>
            </Show>
            <Text>
              Instantly explore living room furniture and decor from top retailers — all inside the DecorMatters app. Drag and drop sofas, rugs, lighting, and tables into your layout to see what fits best before you buy.
              <br />
              <br />
              Test styles, compare pieces, and design your ideal living room using real products, all in one place.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Shop Living Room Furniture from Top Retailers in the App</H2>
            </Show>
            <Image src={img3} alt="Living room with furniture from app’s virtual catalog" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Upgrade to Unlock Advanced Living Room Design Features</H2>
            </Show>
            <Text>
              Go beyond the basics with premium tools made for serious living room design. Upload real photos of your space, place furniture with AR, and save products you love to build your perfect layout. With DecorMatters Membership, you get full
              access to advanced features that make designing your living room faster, smarter, and more personalized.
              <br />
              <br />
              ● Upload photos of your actual living room for accurate designs
              <br />
              ● Use the AR ruler to measure and preview furniture in your space
              <br />
              ● Save your favorite decor and products in one place
              <br />● Remove backgrounds from furniture photos for cleaner layouts
            </Text>
            <Button onClick={openLogin}>Unlock Premium Tools</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Upgrade to Unlock Advanced Living Room Design Features</H2>
            </Show>
            <Image src={img4} alt="DecorMatters premium features comparison screen" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Start Designing Now
              </ButtonLink>
            </Show>
            <Image src={img5} alt="DecorMatters app showing living room redesign interface" />
            <Content>
              <H2>Download the Living Room Design App That Brings Your Ideas to Life</H2>
              <Text>
                Start designing your living room today with the DecorMatters app. Plan layouts, try furniture, and decorate your space with easy drag-and-drop tools. Visualize changes before making them — and turn your ideas into reality without the
                guesswork. Download now to see your living room in a whole new way.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Kitchen
